import IconButton from "../../../components/IconButton";
import Spinner from "../../../components/Spinner";
import { IconCheckCircle, IconXBorder, IconXBorderJSX } from "../../../icons";
import "./index.scss";

export const Validating = () => {
  return (
    <>
      <Spinner
        status={true}
        alternativeChildren={
          <>
            <h1 className="text-2rem text-center pt-12 uppercase font-bold">Validando dados...</h1>
          </>
        }
      ></Spinner>
    </>
  );
};

export const Success = () => {
  return (
    <>
      <div className="flex justify-center items-center" style={{ height: "90vh" }}>
        <div className="successBorder h-96 w-96"></div>
        <div className=" bg-white flex flex-col justify-center items-center rounded-full text-green-700 text-6xl font-bold shadow-xl h-96 w-96 gap-12">
          <div className="flex items-center">
            <IconButton icon={IconCheckCircle} />
            Sucesso
          </div>
          <p className="text-center text-1.4rem">Operação efetuada com sucesso!</p>
        </div>
      </div>
    </>
  );
};

export const Error = () => {
  return (
    <>
      <div className="flex justify-center items-center" style={{ height: "90vh" }}>
        <div className="errorBorder h-96 w-96"></div>
        <div className=" bg-white flex flex-col justify-center items-center rounded-full text-red-700 text-2rem font-bold shadow-xl h-96 w-96 gap-4">
          <div className="flex items-center">
            <IconButton icon={<IconXBorderJSX width="30" />} className="error-icon-payment" />
            Erro
          </div>
          <p className="text-center text-1.4rem">Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente.</p>
        </div>
      </div>
    </>
  );
};
